/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AddPatchPastiCollaboratoriDTO } from './addPatchPastiCollaboratoriDTO';
import { AddPatchPastiDocentiDTO } from './addPatchPastiDocentiDTO';
import { AddPatchPastiPersonaleAtaDTO } from './addPatchPastiPersonaleAtaDTO';
import { AddPatchPastiPersonaleTecnicoDTO } from './addPatchPastiPersonaleTecnicoDTO';

export interface AddPatchPastiDipendentiDTO { 
    numeroPastiTotaleDocenti?: number;
    numeroPastiTotalePersonaleAta?: number;
    numeroPastiTotaleCollaboratori?: number;
    numeroPastiTotalePersonaleTecnico?: number;
    pastiDocenti?: AddPatchPastiDocentiDTO;
    pastiPersonaleAta?: AddPatchPastiPersonaleAtaDTO;
    pastiPersonaleTecnico?: AddPatchPastiPersonaleTecnicoDTO;
    pastiCollaboratori?: AddPatchPastiCollaboratoriDTO;
}